import { iotConfigType, iotConfigUseTab, UnionIotConfigUseTab } from "src/api/iot/iot-config-type";
import { IoTDeviceRegistration } from "src/api/iot/iot-types";

type DefaultTab = {
  type: UnionIotConfigUseTab;
  labelValue: string[];
  name: string;
  registeredDevices: IoTDeviceRegistration[];
};

// 디스플레이 설정 탭
export const iotDisplayTabs = [
  {
    label: "IoT 탭 - 공간 정보",
    value: iotConfigType.DISPLAY_SPACE,
  },
  {
    label: "IoT 탭 - 기기 제어",
    value: iotConfigType.DISPLAY_DEVICE_CONTROL,
  },
];

// 공간정보 기본탭 목록
export const spaceDisplayDefaultTabs: DefaultTab[] = [
  {
    type: iotConfigUseTab.DEFAULT_TAB,
    name: "실내환경",
    labelValue: ["온도", "AIR_QUALITY"],
    registeredDevices: [],
  },
  {
    type: iotConfigUseTab.DEFAULT_TAB,
    labelValue: [],
    name: "혼잡도 (CCTV)",
    registeredDevices: [],
  },
  {
    type: iotConfigUseTab.DEFAULT_TAB,
    labelValue: ["화장실"],
    name: "화장실",
    registeredDevices: [],
  },
  {
    type: iotConfigUseTab.DEFAULT_TAB,
    labelValue: ["폰부스"],
    name: "폰부스",
    registeredDevices: [],
  },
];

// 기기제어 기본탭 목록
export const controlDeviceDefaultTabs: DefaultTab[] = [
  {
    type: iotConfigUseTab.DEFAULT_TAB,
    labelValue: ["공조"],
    name: "냉난방",
    registeredDevices: [],
  },
  {
    type: iotConfigUseTab.DEFAULT_TAB,
    labelValue: ["조명"],
    name: "조명",
    registeredDevices: [],
  },
  {
    type: iotConfigUseTab.DEFAULT_TAB,
    labelValue: ["루버"],
    name: "루버",
    registeredDevices: [],
  },
  {
    type: iotConfigUseTab.DEFAULT_TAB,
    labelValue: ["WASHER", "DRYER"],
    name: "세탁기/건조기",
    registeredDevices: [],
  },
  {
    type: iotConfigUseTab.DEFAULT_TAB,
    labelValue: ["TV"],
    name: "TV",
    registeredDevices: [],
  },
  {
    type: iotConfigUseTab.DEFAULT_TAB,
    labelValue: ["VACUUM"],
    name: "청소기",
    registeredDevices: [],
  },
];

// 사용할 디스플레이 탭
export const iotDisplayUseTabs = [
  {
    label: "기본 탭",
    value: iotConfigUseTab.DEFAULT_TAB,
  },
  {
    label: "커스텀 탭",
    value: iotConfigUseTab.CUSTOM_TAB,
  },
] as const;
